module.exports = __webpack_public_path__ + "static/media/Milex-Gehrung-Pessary-Instructions-for-Use.4cf77dff.jpg";